import useWidth from '@hooks/useWidth'

export default function useLimit() {
  const width = useWidth()
  if (width >= 1024) return 6 
  if (width >= 768) return 4
  return 4
}
